<template>
    <div
        v-show="loadedNext"
        class="upNextWrapper"
    >
        <template v-if="nextMajor">
            <div id="upNext">
                <div class="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-ios">
                    <div class="swiper-wrapper">
                        <course-card
                            v-if="nextCourse && topicsIndex[nextCourse.topicId]"
                            :course="nextCourse"
                            :topic="topicsIndex[nextCourse.topicId]"
                            :link="`/courses/${nextCourse.id}`"
                            :key="`t-next-course-${nextMajor}`"
                            :locked="false"
                            :is-learn="true"
                            :set-course-on-click="true"
                            :in-popup="inPopup"
                            :is-logical-next="true"
                            :is-next-up="true"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="inPopup && coursesIndex[courseId] && topicsIndex[coursesIndex[courseId]]">
            <div class="exploreContentSection hasReverse">
                <h2 style="margin: 50px 0 20px 0px; line-height: 20px; text-align: center">You have completed</h2>
                <f7-block style="margin: 0px 0 20px 0">
                    <p>{{ topicsIndex[coursesIndex[courseId].topicId].name }}</p>
                    <div
                        :style="`background-color: ${topicsIndex[coursesIndex[courseId].topicId].color}`"
                        class="smallTile"
                    />
                    <div
                        :style="`background-color: ${topicsIndex[coursesIndex[courseId].topicId].color}`"
                        class="smallTile"
                    />
                    <div
                        :style="`background-color: ${topicsIndex[coursesIndex[courseId].topicId].color}`"
                        class="smallTile"
                    />
                </f7-block>
                <br>
            </div>
        </template>
        <!--  && !(nextMajor !== 0 && courseId === 66) -->
        <template v-if="nextCourses.length > 0">
            <div :class="nextMajor ? 'exploreContentSection' : ''">
                <h2 style="margin: 50px 0 26px 0px; line-height: 20px; text-align: center">{{ nextMajor ? 'Want to mix it up?' : 'Your next journey' }}</h2>

                <f7-swiper :params="{slidesOffsetBefore: 0, speed:500, slidesPerView: 'auto', spaceBetween: 6, centerInsufficientSlides: true}">
                    <template v-for="(course, j) in nextCourses">
                        <course-card
                            v-if="course && topicsIndex[course.topicId]"
                            :course="course"
                            :topic="topicsIndex[course.topicId]"
                            :link="`/courses/${course.id}`"
                            :key="`t-next-c-${j}`"
                            :is-learn="true"
                            :locked="false"
                            :set-course-on-click="true"
                            :in-popup="inPopup"
                            :is-next-up="true"
                        />
                    </template>
                </f7-swiper>
                <br><br>
                <!--  && !(nextMajor !== 0 && courseId === 66) -->
                <f7-block
                    v-if="inPopup && nextCourses.length > 0"
                    class="center"
                >
                    <f7-link @click="closeAndGoTo('/explore/')">Not what you had in mind?<br>Go explore!</f7-link>
                    <br><br>
                </f7-block>
            </div>
        </template>

    </div>
</template>

<script>
import CourseCard from '../components/courseCard.vue';

import utils from '../js/utils';
import { CORAL_BRANDING } from '../js/constants';

export default {
    components: {
        CourseCard
    },
    props: ['courseId', 'inPopup'],
    store: ['api', 'user', 'topicsIndex', 'courses', 'coursesIndex', 'currentTab', 'fullDataIndex', 'nextMajor', 'myTraits'],
    data () {
        return {
            nextCourse: {
                id: 0,
                name: '',
                description: '',
                data: {},
                topicId: 0,
            },
            // nextMajor sent to home for bg color page
            nextMinor: [],
            nextCourses: [],
            maxNextUps: 2,
            loadedNext: false
        };
    },
    watch: {
        'courseId': function () {
            this.getWhatsNext();
        }
    },
    mounted: function () {
        // this.getWhatsNextApi();
        this.getWhatsNext();
    },
    methods: {
        getWhatsNext: function () {
            this.nextCourses = [];
            this.nextMajor = 0;
            let topicId = this.coursesIndex[this.courseId] ? this.coursesIndex[this.courseId].topicId : 0;
            if (!this.fullDataIndex[topicId]) {
                this.loadedNext = true;
                return console.error('No such topic in index', topicId);
            }
            let courses = this.fullDataIndex[topicId].courses;
            for (let i = 0; i < courses.length; i++) {
                const c = courses[i];
                if (c.id === this.user.currentCourseId
                    && i !== courses.length - 1
                    && !courses[i + 1].comingSoon) {
                    this.nextMajor = courses[i + 1].id;
                    break;
                }
            }
            if (this.nextMajor) this.nextCourse = this.coursesIndex[this.nextMajor];
            const shuffle = (array) => {
                array.sort(() => Math.random() - 0.5);
            };
            this.nextMinor = JSON.parse(JSON.stringify(this.courses));
            shuffle(this.nextMinor)
            for (let i = 0; i < this.nextMinor.length; i++) {
                let course = this.coursesIndex[this.nextMinor[i].id];
                if (course && course.topicId !== 5 && !course.comingSoon && this.user.currentCourseId !== course.id &&
                    utils.checkTraits(this.myTraits, course) && course.topicId !== topicId && this.nextCourses.length < this.maxNextUps + 1) {
                    let eligible = 0;
                    let completed = 0;
                    if (course.units) {
                        for (let i = 0; i < course.units.length; i++) {
                            const u = course.units[i];
                            if (utils.checkTraits(this.myTraits, u)) eligible++;
                            if (u.completed) completed++;
                        }
                        if (eligible > 0 && completed < eligible)
                            this.nextCourses.push(course);
                    }

                }
            }
            // console.log(this.nextCourses)
            this.loadedNext = true;
        },
        getWhatsNextApi: function () {
            this.nextCourses = [];
            this.$http.get(`${this.api}/feed/${this.user.currentCourseId}`).then(
                response => {
                    this.nextMajor = 0; // = response.body.nextMajor || 
                    this.nextMinor = response.body.nextMinor || [];

                    // override server nextmajor with local one
                    let topicId = this.coursesIndex[this.user.currentCourseId] ? this.coursesIndex[this.user.currentCourseId].topicId : 0;
                    if (!this.fullDataIndex[topicId]) {
                        this.loadedNext = true;
                        return console.error('No such topic in index', topicId);
                    }
                    let courses = this.fullDataIndex[topicId].courses;
                    for (let i = 0; i < courses.length; i++) {
                        const c = courses[i];
                        if (!this.nextMajor &&
                            c.id === this.user.currentCourseId
                            && i !== courses.length - 1
                            && !courses[i + 1].comingSoon) {
                            this.nextMajor = courses[i + 1].id;
                        }
                    }
                    if (this.nextMajor) this.nextCourse = this.coursesIndex[this.nextMajor];
                    for (let i = 0; i < this.nextMinor.length; i++) {
                        if (this.coursesIndex[this.nextMinor[i]] && !this.coursesIndex[this.nextMinor[i]].comingSoon)
                            this.nextCourses.push(this.coursesIndex[this.nextMinor[i]]);
                    }
                    this.loadedNext = true;
                },
                response => {
                    console.error(response.body.message || 'Unknown error 1102');
                }
            );
        },
        setCourse: function (id) {
            console.log('this.inPopup', this.inPopup);
            if (this.inPopup) {
                f7.popup.get(`#${this.inPopup}`).open();
                f7.popup.get(`#${this.inPopup}`).close();
            } else if (this.courseId === CORAL_BRANDING && this.nextMajor !== 0) {
                // What was this again?
            }
            this.nextMajor = 0;
            this.user.currentCourseId = id;
            this.$events.fire('user-save', () => {
                this.$events.fire('reload-home');
            });
        },
        closeAndGoTo: function (url) {
            if (url === '/explore/') this.currentTab = 'explore';
            if (url === '/goals') this.currentTab = 'goals';
            f7.views['main'].router.navigate(url, { clearPreviousHistory: true });
            if (this.inPopup) {
                f7.popup.get(`#${this.inPopup}`).open();
                f7.popup.get(`#${this.inPopup}`).close();
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.center {
    text-align: center;
}
.upNextWrapper {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    background: white;
}
#upNext {
    // border-top: 30px solid white;
    background: white;
    border-bottom: 30px solid white;
    width: 100%;
    .bigTile {
        margin: -52px auto;
    }
    .swiper-slide {
        margin: 10px auto !important;
    }
}
.exploreContentSection {
    position: relative;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    background-color: @darkBackground;
    background-image: url('../img/0.4/bgwave.png');
    // background-size: 307px 11px;
    background-size: 460.5px 16.5px;
    background-position: top left;
    background-repeat: repeat-x;
    &.hasReverse:before {
        position: absolute;
        bottom: 0px;
        content: '';
        width: 100vw;
        height: 16.5px;
        background-position: bottom left;
        background-size: 460.5px 16.5px;
        background-image: url('../img/0.4/bgwave.png');
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}
.smallTile {
    height: 60px;
    width: 40px;
    border-radius: 8px;
    display: inline-block;
}
.theme-dark {
    .upNextWrapper {
        background: #000;
        h2 {
            color: white;
        }
    }
    #upNext {
        background: black;
        border-bottom: 30px solid #000;
    }
    .exploreContentSection {
        background-color: #1c1c1d;

        background-image: url('../img/0.4/bgwavedark.png');
    }
}
</style>
